// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import CalculatorPage from "./pages/CalculatorPage";
import HomeScreen from "./pages/HomeScreen";
import Services from "./pages/Services";
import BlogPage from "./pages/BlogPage";
import Contact from "./pages/Contact";
import BlogMain from "./pages/BlogMain"; // Detailed blog page

// Admin components
import Login from "./pages/admin/Login";
import Layout from "./pages/admin/Layout";
import Dashboard from "./pages/admin/Dashboard";
import Enquiries from "./pages/admin/Enquiries";
import Blogs from "./pages/admin/Blogs";
import AddBlog from "./pages/admin/AddBlog";
import QuotationSettings from "./pages/admin/QuotationSettings";

// Import the PrivateRoute component
import PrivateRoute from "./PrivateRoute";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomeScreen />} />
        <Route path="/solar-savings-calculator" element={<CalculatorPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blogs" element={<BlogPage />} />
        <Route path="/contact" element={<Contact />} />
        {/* Detailed Blog Page Route */}
        <Route path="/blogs/:id" element={<BlogMain />} />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<Login />} />
        <Route 
          path="/admin/" 
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="enquiries" element={<Enquiries />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="blogs/add" element={<AddBlog />} />
          <Route path="quotationSettings" element={<QuotationSettings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
